"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setsAreEqual = function (setA, setB) {
    if (setA.size !== setB.size) {
        return false;
    }
    var diff = new Set(setB);
    setA.forEach(function (item) {
        diff.delete(item);
    });
    return diff.size === 0;
};
